import {VECTOR_STYLE_SOURCE_NAME} from 'Map/tier/trafficIncidentTilesTier';

function modifiedReloadTileMethod(id, state) {
    if (state === 'expired') {
        return this._tiles[id];
    }

    return this._originalReloadTile(id, state);
}

export default function modifyCacheForCertainTiers(map) {
    const trafficFlowTilesSourceName = 'vectorTilesTraffic';
    const sourceNamesWithCacheModified = [trafficFlowTilesSourceName, VECTOR_STYLE_SOURCE_NAME];
    const sourceCaches = map.__om.style.sourceCaches;
    sourceNamesWithCacheModified.forEach((sourceName) => {
        const sourceCache = sourceCaches[sourceName];
        const notExistsOrIsAlreadyModified = Boolean(!sourceCache || sourceCache._originalReloadTile);
        if (notExistsOrIsAlreadyModified) {
            return;
        }
        sourceCache._originalReloadTile = sourceCache._reloadTile;
        sourceCache._reloadTile = modifiedReloadTileMethod;
    });
}



// WEBPACK FOOTER //
// ./map/map/tileCacheModifier.js